import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { PDIGraphData } from '../../types/device';
type ContextState = Data<PDIGraphData>;
const Context = React.createContext<ContextState | null>(null);
function usePDIGraphDetails(): ContextState{
    const contextState = React.useContext(Context);
    if(contextState === null){
        throw new Error('usePDIGraph details must be used within a PDI Graph');
    }
    return contextState;
}

const PDIGraphDataProvider: React.FC<{ deviceId: string; channelNumber: any; startDate: string; endDate: string}> = (props) => {
       const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'PDI-graph',
        id:`${props.deviceId}-${props.channelNumber}-${props.startDate}-${props.endDate}`,
        dataFn: React.useCallback(
            (): Promise<PDIGraphData> => ChartManager.getPDIGraphResponse(authHelper,props.deviceId,props.channelNumber,props.startDate,props.endDate),
            [
            authHelper,
            props.deviceId,
            props.channelNumber,
            props.startDate,
            props.endDate
           
           
        ]),
    });
   
    const pdiGraphData = dataFromDataset(dataset);  
    return <Context.Provider value={pdiGraphData}>{props.children}</Context.Provider>;
};
const TestPDIGraphDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { TestPDIGraphDataProvider, PDIGraphDataProvider, usePDIGraphDetails };